import LoadingIcon from 'src/assets/icons/LoadingIcon';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { colors } from 'src/config/colors';
import { below, media, widthBreakpoints } from 'src/config/breakpoints';
import { typography } from 'src/config/typography';
import { useMediaQuery } from 'src/common/migration/useMediaQuery';

export type LoaderType = 'primary' | 'secondary';

export const LoaderContainer = styled.div<{ $type: LoaderType }>`
  color: ${({ $type }) => ($type === 'primary' ? colors.red : colors.white)};
  padding: 1.875rem 0 3.3125rem;
  text-align: center;

  ${media.w.min.px576(css`
    padding-top: 3.375rem;
  `)};
`;

const LoaderText = styled.div`
  font-family: ${typography.fontFamilyDefault};
  font-weight: 600;
  font-size: 0.625rem;
  line-height: 1rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  margin-top: 0.625rem;

  ${media.w.min.px992(css`
    margin-top: 0.9375rem;
    font-size: 0.75rem;
  `)};
`;

export interface LoaderProps {
  type?: 'primary' | 'secondary';
}

export const Loader: FC<LoaderProps> = ({ type }) => {
  const notDesktop = useMediaQuery({ maxWidth: below(widthBreakpoints.px992) });
  return (
    <LoaderContainer $type={type ?? 'primary'}>
      <LoadingIcon size={notDesktop ? 32 : 64} />
      <LoaderText>ŁADOWANIE...</LoaderText>
    </LoaderContainer>
  );
};
